/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardVMIEnumerableApiResponse } from '../models/DashboardVMIEnumerableApiResponse';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * @returns DashboardVMIEnumerableApiResponse Success
     * @throws ApiError
     */
    public static async getSummaryDashboard(): Promise<DashboardVMIEnumerableApiResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/dashboard`,
        });
        return result.body;
    }

}